import React from "react";
import Collapsible from "react-collapsible";
import ModuleContent from "./ModuleContent";
import ModuleAccordionHeader from "./ModuleAccordionHeader";
import { observer, inject } from "mobx-react";
import { observe } from "mobx";
import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import classNames from "classnames";
import HttpClient from "services/HttpClient";
const GET_MODULE = "/api/v1/modules/";
@inject("organizationWebinarCreate")
@inject("deleteModal")
@inject("user")
@observer
export default class AccordionModule extends React.Component {
  state = { opened: false, description: '' };

  componentWillMount = () => {
    this.setState({ id: this.props.id }, () => this.handleOpening());
  };

  handClose = () => {
    this.props.organizationWebinarCreate.handleChangeOpenedEntity({ type: "none", id: 0 });
  };

  focusModule = () => {
    setTimeout(this.bringMeFocus, 600);
  };

  bringMeFocus = () => {
    console.log("module scrolled");
    document
      .getElementsByClassName("Collapsible accordion-item is-active")[0]
      .scrollIntoView();
  };

  componentDidMount = () => {
    this.stateObserve = observe(
      this.props.organizationWebinarCreate,
      "openedEntity",
      () => {
        this.handleOpening();
      }
    );
  };

  handleOpening = () => {
    let openedEntity = this.props.organizationWebinarCreate.openedEntity;
    if (openedEntity.type === "module" && openedEntity.id === this.state.id)
      this.setState({ opened: true });
    else {
      if (
        this.state.opened ||
        (openedEntity.type === "module" || openedEntity.type === "workshop")
      )
        this.setState({ opened: false });
    }
  };

  componentWillReceiveProps = newProps => {
    this.setState({ id: newProps.id });
  };

  componentWillUnmount = () => {
    this.stateObserve();
  };

  handler = () => {
    let currentModuleId = _.findIndex(
      this.props.organizationWebinarCreate.modules,
      el => el.key === this.state.id
    );
    let currentModule = this.props.organizationWebinarCreate.modules[currentModuleId];
    if (
      this.props.organizationWebinarCreate.openedEntity.type === "module" &&
      this.props.organizationWebinarCreate.openedEntity.id === this.state.id
    ) {
      this.props.organizationWebinarCreate.handleChangeOpenedEntity({
        type: "none",
        id: 0
      });
    } else
      this.props.organizationWebinarCreate.handleChangeOpenedEntity({
        type: "module",
        id: this.props.id
      });
    new HttpClient().get(`${GET_MODULE}${currentModule.id}`).then(response => {
      this.setState({description: response.body.module.description || ''});
    });
  };

  handleDelete = () => {
    let currentModuleId = _.findIndex(
      this.props.organizationWebinarCreate.modules,
      el => el.key === this.state.id
    );
    let currentModule = this.props.organizationWebinarCreate.modules[currentModuleId];
    if (currentModule.id)
      this.props.deleteModal.eventDelete({
        type: "module",
        id: currentModule.id,
        index: this.state.id
      });
    else this.props.organizationWebinarCreate.deleteModule(this.state.id);
  };

  render() {
    const {description} = this.state;
    const workshop = this.props.organizationWebinarCreate.workshop;
    let currentModuleId = _.findIndex(
      this.props.organizationWebinarCreate.modules,
      el => el.key === this.state.id
    );
    let currentModule = this.props.organizationWebinarCreate.modules[currentModuleId];
    let newCaption = "";
    let details = currentModule.details ? currentModule.details.replace(/<(?:.|\n)*?>/gm, '') : '';
    let desc = details || description;
    if (desc && desc !== "") {
      newCaption = document.createElement("div");
      newCaption.innerHTML = desc.replace(/<\/p>/gm, ' ').replace(/<(?:.|\n)*?>/gm, '');
      newCaption = newCaption.textContent;
    }
    const data = {
      head: {
        label: currentModule.title,
        icon: "ic-flag-ico",
        caption: newCaption,
        withBtn: false,
        open: this.state.opened
      }
    };
    let currentErrors;
    if (this.props.organizationWebinarCreate.modulesError.length - 1 < [currentModuleId])
      currentErrors = {};
    else
      currentErrors = this.props.organizationWebinarCreate.modulesError[currentModuleId];

    let hasErrors = false;
    let length = 0;

    if (!_.isEmpty(currentErrors)) {
      currentErrors.questionError.forEach(el => {
        if (_.has(el, "text")) length++;
      });
      hasErrors =
        _.has(currentErrors, "title") ||
        _.has(currentErrors, "description") ||
        length !== 0;
    }
    const user = this.props.user.getUser();
    const trigger = (
      <div className={classNames({ "module-has-error": hasErrors })}>
        <ModuleAccordionHeader
          label={!!data.head.label ? data.head.label : "Module label"}
          number={currentModuleId + 1}
          canDelete={
            (user.role === "admin" || user.id === workshop.created_by) || !currentModule.id
          }
          caption={
            !!data.head.caption
              ? data.head.label.substr(0, 100)
              : "Module description"
          }
          handleDelete={this.handleDelete}
        />
      </div>
    );

    return (
      <Collapsible
        className="accordion-item"
        openedClassName="accordion-item is-active"
        open={data.head.open}
        trigger={trigger}
        onOpen={() => this.focusModule()}
        handleTriggerClick={this.handler}
      >
        <ModuleContent index={currentModuleId} handleClose={this.handClose} description={desc} />
      </Collapsible>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_organization_webinar/create_module/AccordionModule.jsx